export class MenuListService {
    constructor($resource, ApiService) {
        'ngInject';

        this.$resource = $resource;
		this.apiService = ApiService;
    }

    getMenuListDetails(details) {
        return {
            overview: this._getOverviewDetails(details.data.menuOverviewDetails),
            list: this._getContentDetails(details.data.children)
        }
    }

    //************************************************Private Methods*********************** */


    _getOverviewDetails(details) {
        return {
            title: details.title,
            description: details.description,
            overview: details.overview,
            image: details.image
        }
    }

    _getContentDetails(content) {
        return content.map(({ title, overview, description, name, slug }) => ({ title, overview, description, name, slug }));
    }
}


// WEBPACK FOOTER //
// ./src/app/components/menu-list/menu-list.service.js